import Vue from 'vue'
import VueI18n from 'vue-i18n'
import store from '@/vuex'
import locales from '@/locales'
import VueSwal from '@/utilities/vue-sweetalert2'
import App from './App'
import axios from 'axios'

// Override Axios Config
axios.interceptors.request.use(config => {
  config.withCredentials = true
  return config
})

Vue.use(VueI18n)
Vue.use(VueSwal)

Vue.config.productionTip = process.env.NODE_ENV === 'development'

let amplitude = void 0

Object.defineProperty(Vue.config, 'amplitude', {
  enumerable: true,
  configurable: true,
  get: () => { return amplitude },
  set: val => { amplitude = val }
})

if ('amplitude' in window) {
  Vue.config.amplitude = window.amplitude.getInstance()
  Vue.config.amplitude.init(process.env.AMPLITUDE)
}

const i18n = new VueI18n({
  locale: 'tw',
  fallbackLocale: 'tw',
  messages: locales
})

/* eslint-disable no-new */
new Vue({
  store: store,
  i18n: i18n,
  el: '#comments-container',
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js